<template>
  <div class="container">
    <div v-if="!isMobile">
      <table>
        <thead>
          <tr>
            <th>Announced Date</th>
            <th>Closed Date</th>
            <th>Transaction Type</th>
            <th>Buyer</th>
            <th>Target</th>
            <th>Status</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in this.transactions" v-bind:key="index">
            <td style="width: 10%">{{ item[0] == "Data Unavailable" ? "-" : item[0].format("DD MMM YYYY") }}</td>
            <td style="width: 10%">{{ item[1] == "Data Unavailable" ? "-" : item[1].format("DD MMM YYYY") }}</td>
            <td>{{ item[2] == "Data Unavailable" ? "-" : item[2] }}</td>
            <td>{{ item[3] == "Data Unavailable" ? "-" : item[3] }}</td>
            <td>{{ item[4] == "Data Unavailable" ? "-" : item[4] }}</td>
            <td>{{ item[5] == "Data Unavailable" ? "-" : item[5] }}</td>
            <td class="right">
              {{
                item[6] == "Data Unavailable"
                  ? "-"
                  : vueNumberFormat(parseFloat(item[6]), { precision: 2 })
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="tx-list">
      <div v-for="(item, index) in transactions" :key="index" class="tx-card">
        <div class="tx-row"><span class="label">Announced</span><span class="val">{{ item[0] == 'Data Unavailable' ? '-' : item[0].format('DD MMM YYYY') }}</span></div>
        <div class="tx-row"><span class="label">Type</span><span class="val">{{ item[2] == 'Data Unavailable' ? '-' : item[2] }}</span></div>
        <div class="tx-row"><span class="label">Buyer</span><span class="val">{{ item[3] == 'Data Unavailable' ? '-' : item[3] }}</span></div>
        <div class="tx-row"><span class="label">Target</span><span class="val">{{ item[4] == 'Data Unavailable' ? '-' : item[4] }}</span></div>
        <div class="tx-row"><span class="label">Status</span><span class="val">{{ item[5] == 'Data Unavailable' ? '-' : item[5] }}</span></div>
        <div class="tx-row"><span class="label">Value</span><span class="val right">{{ item[6] == 'Data Unavailable' ? '-' : vueNumberFormat(parseFloat(item[6]), { precision: 2 }) }}</span></div>
      </div>
    </div>
  </div>
</template>
<script>
  const jp = require('jsonpath');
  const moment = require('moment');
  import api from '@/api/dashboard1.js';

export default {
  name: "KeyTransactions",
  data: () => {
    return {
      transactions: []
    }
  },
  computed: {
    isMobile(){ return (typeof window !== 'undefined' && window.innerWidth <= 768) }
  },
  methods: {
    render: async function (q) {
      this.transactions.splice(0, this.transactions.length);
      let r = await api.fetchTransactionList(q);
      const transactionIds = jp.query(r, "$..Row[0]");

        r = await api.fetchTransactionDetails(transactionIds);
        const transactionDetails = jp.query(r, '$..Row[0]');
        const chunkSize = transactionDetails.length / transactionIds.length;
        for (let i = 0; i < transactionDetails.length; i += chunkSize) {
          // announced date
          if (transactionDetails[i] != 'Data Unavailable') {
            transactionDetails[i] = moment(transactionDetails[i], 'MM/DD/YYYY');
          }
          // closed date
          if (transactionDetails[i + 1] != 'Data Unavailable') {
            transactionDetails[i + 1] = moment(
              transactionDetails[i + 1],
              'MMM DD YYYY h:mmA'
            );
          }
          this.transactions.push(transactionDetails.slice(i, i + chunkSize));
        }
      },
    },
  };
</script>
<style scoped>
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

  .container table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 5px;
    overflow: hidden;
    margin-top: 1em;
  }

  .container td,
  th {
    padding: 10px;
    background-color: #fafafa;
    text-align: left;
    border: 2px solid #ddd;
  }

  .container td {
    text-align: left;
  }

  .container thead th {
    text-align: center;
  }

  .container td {
    background-color: #fefefe;
  }

.container td.right {
  text-align: right;
}

/* Mobile list view for transactions */
.tx-list { display:flex; flex-direction:column; gap:8px }
.tx-card { padding:8px; border-radius:6px; background:#fff; box-shadow:0 0 0 1px #eee }
.tx-row { display:flex; justify-content:space-between; gap:8px; padding:6px 0 }
.tx-row .label { color:#666; font-size:12px }
.tx-row .val { color:#111; font-size:13px }

@media (max-width:768px){
  .container { width:100%; padding:6px }
  .container table { font-size:13px }
}
</style>
